import _ from "lodash";
import { getProjectGroupContexts } from "Platform/modules/PlatformUtils";

export const getRnPQueryVariablesForProjectGroupCategories = projectGroupCategories => {
  const contexts = _.map(projectGroupCategories, projectGroupCategory => {
    const id = _.get(projectGroupCategory, "id");

    const curriculumProgramId = _.get(
      projectGroupCategory,
      "curriculumProgram.id"
    );
    return getProjectGroupContexts({
      projectGroupCategoryId: id,
      curriculumProgramId,
    });
  });
  return {
    filters: {
      module: "PROJECTS",
      appType: "TEACHER_WEB",
      contexts,
    },
  };
};
